// @flow
import React, { useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useForm, FormProvider } from 'react-hook-form';
import { isMobile } from 'react-device-detect';
import { HeaderContainer, HeaderContent } from 'components/shared/PageHeader/PageHeader';
import bgImage from 'assets/images/background.png';
import customizeActions from 'actions/customize';
import purchaseActions from 'actions/purchase';
import { sendAnalyticsEvent } from 'utils/analyticsWrapper';
import GoalcardPreview from './GoalcardPreview/index';
import GoalcardSupportOptions from './GoalcardSupportOptions/index';
import GoacardCustomization from './GoalcardCustomization/index';

import {
  PageContainer,
  OptionContanier,
  GoalcardContainer,
  ButtonContainer,
  Button,
} from './Styles';

type CustomizeProps = {
  receiverUser: any,
  selectedCard: any,
  goalcardPayload: any,
  isProcessing: boolean,
  getGoals(userId: string): [{}],
  setGoalcardPayload(paylaod: any): void
};

const Customize = (props: CustomizeProps) => {
  const { t } = useTranslation();
  const history = useHistory();

  const [goalcardPosition, setGoalcardPosition]: [any, ((any => any) | any) => void] = useState({});
  const methods = useForm({ mode: 'onBlur', reValidateMode: 'onBlur' });
  const inputRef = useRef(null);

  const {
    receiverUser, selectedCard, goalcardPayload, isProcessing, receiverGoal,
  } = props;

  const {
    rid, firstname, firstnameWithPossesive, fullName, gender,
  } = receiverUser || {};

  const { cardId, cardImageUrl } = selectedCard || {};

  const { rid: goalId, prettyName } = receiverGoal || {};

  console.log('GOAL ID', goalId);

  const headerTitle = rid ? t('customize_headeruser_title', { firstnameWithPossesive }) : t('customize_headernonuser_title');

  const [pageState, updatePageState]: [any, ((any => any) | any) => void] = useState({
    amount: goalcardPayload?.amount || 0,
    receiverEmail: goalcardPayload?.destination || '',
    investorName: goalcardPayload?.investorName || '',
    investorEmail: goalcardPayload?.investorEmail || '',
    scheduledDate: goalcardPayload?.executionDate || '',
    description: goalcardPayload?.description || '',
    goalcardContainerStyle: {},
    containerHeight: 0,
    uploadedMedia: goalcardPayload?.uploadedMedia || '',
    valuesByGoal: goalcardPayload?.valuesByGoal,
    // receiverName: goalcardPayload?.whoIsCardFor || fullName || '',
    receiverName: goalcardPayload?.whoIsCardFor,
    destinationType: goalcardPayload?.destinationType || 'parent',
    supportType: goalcardPayload?.supportType,
  });

  const handleScroll = () => {
    if (inputRef && inputRef.current) {
      const totalHeight = (inputRef.current.offsetHeight / 2);
      if (window.pageYOffset < totalHeight && window.innerWidth > 768) {
        setGoalcardPosition({ goalcardContainerStyle: { marginTop: `${window.pageYOffset}px` } });
      }
      if (window.innerWidth < 768) {
        setGoalcardPosition({ goalcardContainerStyle: { marginTop: '0px' } });
      }
    }
  };

  useEffect(() => { }, [inputRef]);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (rid) {
      props.getGoals(rid);
    }
    // updatePageState({
    //   amount: 0,
    //   investorName: '',
    //   investorEmail: '',
    //   scheduledDate: '',
    //   description: '',
    //   goalcardContainerStyle: {},
    //   containerHeight: 0,
    //   uploadedMedia: '',
    //   valuesByGoal: [],
    //   receiverName: fullName || '',
    // });

    function watchScroll() {
      window.addEventListener('scroll', handleScroll);
    }

    watchScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  if (!goalcardPayload) {
    if (!receiverUser && !receiverGoal) {
      history.push('/gift');
    }

    if (!cardId || !cardImageUrl) {
      history.push('/selectgoalcard');
    }
  }

  const setAmountCallback = (amount) => {
    updatePageState({ ...pageState, amount });
  };

  const amountByGoalCallback = (valuesByGoal) => {
    updatePageState({ ...pageState, valuesByGoal });
  };

  const setUploadedMediaCallback = (uploadedMedia) => {
    sendAnalyticsEvent('Customize Goalcard', 'customize_goalcard_media_uploaded');
    updatePageState({ ...pageState, uploadedMedia });
  };

  const setInvestorCallback = (investorName, investorEmail) => {
    updatePageState({ ...pageState, investorName, investorEmail });
  };

  const setReceiverCallback = (receiverName) => {
    updatePageState({ ...pageState, receiverName });
  };

  function yyyymmdd(dateIn) {
    const yyyy = dateIn.getFullYear();
    const mm = dateIn.getMonth() + 1;
    const dd = dateIn.getDate();
    return String(`${yyyy}-${mm}-${dd}`);
  }

  const onSubmit = (data) => {
    sendAnalyticsEvent('Customize Goalcard', 'customize_goalcard_to_purchase');

    const { setGoalcardPayload } = props;

    let receiverFirstname = '';
    let receiverLastname = '';
    let scheduledDate = '';

    if (data.receiverName) {
      receiverFirstname = data.receiverName.split(' ').slice(0, -1).join(' ');
      receiverLastname = data.receiverName.split(' ').slice(-1).join(' ');

      if (receiverFirstname === '' && receiverLastname !== '') {
        receiverFirstname = receiverLastname;
        receiverLastname = '';
      }
    } else if (fullName) {
      receiverFirstname = fullName.split(' ').slice(0, -1).join(' ');
      receiverLastname = fullName.split(' ').slice(-1).join(' ');
    }

    if (data.scheduledDate) {
      scheduledDate = yyyymmdd(data.scheduledDate);
    }

    const payload = {
      creditCardToken: '',
      amount: data.goalcardAmount,
      description: data.description,
      imageUrl: pageState.uploadedMedia.base64Image,
      videoUrl: pageState.uploadedMedia.videoUrl,
      uploadedMedia: pageState.uploadedMedia,
      goalcardImage: cardImageUrl,
      destinationId: rid,
      destination: data.receiverEmail,
      destinationFirstname: receiverFirstname,
      destinationLastname: receiverLastname,
      destinationType: data.receiverType,
      executionDate: scheduledDate,
      whoIsCardFor: data.receiverName,
      goalPrettyName: prettyName,
      investorName: pageState.investorName,
      investorEmail: pageState.investorEmail,
      isSpecified: false,
      childs: [],
      supportType: 'nonspecific',
      valuesByGoal: pageState.valuesByGoal,
    };

    console.log('PAGE STATE', pageState);

    if (pageState.valuesByGoal && pageState.valuesByGoal.length > 0) {
      pageState.valuesByGoal.map((x) => {
        if (x.value && x.goalId) {
          payload.childs.push({ key: x.goalId, value: x.value });
        }
        return payload.childs;
      });

      payload.isSpecified = true;
      payload.supportType = 'specific';
    } else if (goalId) {
      payload.childs.push({ key: goalId, value: data.goalcardAmount });
      payload.isSpecified = true;
      payload.supportType = 'specific';
    }

    setGoalcardPayload(payload);

    history.push('/purchase');
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <HeaderContainer backgroundImage={bgImage}>
          <HeaderContent>
            {headerTitle}
          </HeaderContent>
        </HeaderContainer>
        <PageContainer mobileView={isMobile}>
          <OptionContanier ref={inputRef}>
            <GoalcardSupportOptions
              userId={rid}
              receiverName={firstname}
              receiverGoalId={goalId}
              receiverNameWithPosessive={firstnameWithPossesive}
              receiverGender={gender}
              setAmountCallback={setAmountCallback}
              amountByGoalCallback={amountByGoalCallback}
              supportType={pageState.supportType}
            />
            <GoacardCustomization
              receiver={receiverUser}
              receiverEmail={pageState.receiverEmail}
              receiverName={pageState.receiverName}
              investorName={pageState.investorName}
              investorEmail={pageState.investorEmail}
              setInvestorCallback={setInvestorCallback}
              setReceiverCallback={setReceiverCallback}
              setUploadedMediaCallback={setUploadedMediaCallback}
              isScheduled={pageState.scheduledDate ? 'scheduled' : 'nonscheduled'}
              scheduledDate={pageState.scheduledDate}
              receiverType={pageState.destinationType}
              description={pageState.description}
              uploadedMedia={pageState.uploadedMedia}
            />
          </OptionContanier>
          <GoalcardContainer style={goalcardPosition.goalcardContainerStyle}>
            <GoalcardPreview
              userId={rid}
              receiverName={pageState.receiverName}
              investorName={pageState.investorName}
              amount={pageState.amount}
              cardImageUrl={cardImageUrl}
              goalPrettyName={prettyName}
            />
          </GoalcardContainer>
        </PageContainer>
        <ButtonContainer mobileView={isMobile}>
          <Button data-testid="btnContinue" type="submit" disabled={isProcessing}>{t('continue_title')}</Button>
        </ButtonContainer>
      </form>
    </FormProvider>
  );
};

// Map Props
const mapStateToProps = (state) => ({
  isProcessing: state.customize.isProcessing,
  goals: state.customize.goals,
  goalcardPayload: state.purchase.goalcardPayload,
  selectedCard: state.selectCard.selectedCard,
  receiverUser: state.gift.receiverUser,
  receiverGoal: state.gift.receiverGoal,
});

// Map Dispatch
const mapDispatchToProps = (dispatch) => ({
  getGoals: (userId: string) => dispatch(
    customizeActions.getPublicGoals(userId),
  ),
  setGoalcardPayload: (payload: any) => dispatch(
    purchaseActions.setGoalcardPayload(payload),
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Customize);
